import { useSnapshot } from 'valtio';

import { refsStore, gmapStore } from '../managers/globalState';
import { GMAP_CATEGORIES } from '../config/constants';
//import momenti from "moment-hijri";
import moment from 'moment-timezone';

const updateYear = newYearIndex => {
	gmapStore.setGlobalState({ yearIndex: newYearIndex });
};

const updateCategory = category => {
	gmapStore.setGlobalState({ categoryIndex: category });
};

/**
 * Loops through all the gmap and creates an array of all years spanning them.
 * @param {Array} allGmap
 * @returns {Array}
 */
const  getAllYearsGmap = allGmap => {
	let allYears = [['all','كل السنوات']];

	allGmap.map(gmap => {
		const currYear = gmap.date.substring(0, 4);
		let all = allYears.filter(v => {
			return v[0] == currYear
		})
		if(all.length == 0){
			const display = moment(gmap.date).format('YYYY');
			allYears.push([currYear,display]);
		}
	});

	return allYears.sort((a, b) => b - a);
};

const filterGmap = ( gmaps, gmapYears, yearIndex, gmapcategoryIndex) => {
  // console.log("filter!!!!!!!!!", gmaps, yearIndex, gmapcategoryIndex)
  return gmaps.filter(gmap => {
      if(GMAP_CATEGORIES.length > 0){
        const year = gmapYears[yearIndex][0];
        const category = GMAP_CATEGORIES[gmapcategoryIndex];
        const yearFilter = year === 'all' || gmap.date.substring(0, 4) === year;
        const categoryFilter = category[0] === 'All Types' || (gmap.imagecategory?.includes(category[0].replace(/ /g, '').toLocaleLowerCase()));
        return yearFilter && categoryFilter;
      }
  })};

export {
	updateYear,
	updateCategory,
	getAllYearsGmap,
	filterGmap
};
